import { render, staticRenderFns } from "./RadioAdaMerkPerusahaan.vue?vue&type=template&id=76199070&"
import script from "./RadioAdaMerkPerusahaan.vue?vue&type=script&lang=js&"
export * from "./RadioAdaMerkPerusahaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports